export const ANALYTICS_EVENTS = {
  APP_AI_TRANSCRIPTION_CONSENT_ACCEPTED: 'app_ai_transcription_consent_accepted',
  APP_AI_TRANSCRIPTION_CONSENT_LOADED: 'app_ai_transcription_consent_loaded',
  APP_DEEP_LINK_HANDLED: 'app_deep_link_handled',
  APP_ONBOARDING_COMPLETED: 'app_onboarding_completed',
  APP_ONBOARDING_SKIPPED: 'app_onboarding_skipped',
  APP_ONBOARDING_STARTED: 'app_onboarding_started',
  APP_ONBOARDING_STEP_CHANGED: 'app_onboarding_step_changed',
  APP_PERMISSION_DENIED: 'app_permission_denied',
  APP_NOTIFICATION_PERMISSION_PROMPT_ENABLED: 'app_notification_permission_enabled',
  APP_NOTIFICATION_PERMISSION_PROMPT_SKIPPED: 'app_notification_permission_skipped',
  APP_PUSH_NOTIFICATION_OPENED: 'app_push_notification_opened',
  APP_PUSH_NOTIFICATION_RECEIVED: 'app_push_notification_received',
  APP_SCREEN_VIEWED: 'app_screen_viewed',
  AUTH_LOGIN_FAILED: 'auth_login_failed',
  AUTH_LOGIN_STARTED: 'auth_login_started',
  AUTH_LOGIN_SUCCESS: 'auth_login_success',
  AUTH_LOGOUT_COMPLETED: 'auth_logout_completed',
  AUTH_OAUTH_CALLBACK_RECEIVED: 'auth_oauth_callback_received',
  AUTH_SESSION_RESTORED: 'auth_session_restored',
  DEAL_MEETING_CONTACT_ATTACHED: 'deal_meeting_contact_attached',
  DEAL_MEETING_CONTACT_MODAL_CLOSED: 'deal_meeting_contact_modal_closed',
  DEAL_MEETING_CONTACT_MODAL_SHOWN: 'deal_meeting_contact_modal_shown',
  DEAL_MEETING_RECORDING_ENDED: 'deal_meeting_recording_ended',
  DEAL_MEETING_RECORDING_STARTED: 'deal_meeting_recording_started',
  DEAL_MEETING_RETRY_EXHAUSTED: 'deal_meeting_retry_exhausted',
  DEAL_MEETING_RETRY_QUEUE_LENGTH: 'deal_meeting_retry_queue_length',
  DEAL_MEETING_UPLOAD_ATTEMPTED: 'deal_meeting_upload_attempted',
  DEAL_MEETING_UPLOAD_RESULT: 'deal_meeting_upload_result',
} as const;

export const ANALYTICS_PARAM_VALUE_MAX_LENGTH = 100;

export const ANALYTICS_PARAMS = {
  ACCEPTED: 'accepted',
  ACCOUNT_ID: 'account_id',
  AUTO_PICKER_OPENED: 'auto_picker_opened',
  CLICKED_TARGET_LABEL: 'clicked_target_label',
  CONTACT_COUNT: 'contact_count',
  CONTACT_ID: 'contact_id',
  CONTACT_IDS: 'contact_ids',
  DURATION_MS: 'duration_ms',
  ERROR_CODE: 'error_code',
  ERROR_STAGE: 'error_stage',
  LENGTH: 'length',
  RECORDING_SESSION_ID: 'recording_session_id',
  MEETING_ID: 'meeting_id',
  NETWORK_TYPE: 'network_type',
  OUTCOME: 'outcome',
  PATH: 'path',
  PERMISSION: 'permission',
  REASON: 'reason',
  RECORDING_ID: 'recording_id',
  RESOURCE_TYPE: 'resource_type',
  SCREEN_NAME: 'screen_name',
  SOURCE: 'source',
  STEP: 'step',
  TRIGGERED_BY: 'triggered_by',
  USER_ID: 'digima_user_id',
} as const;
